require('./style.less');

var Modal = require('../../common/modal/modal'),
    Util = require('../../FV/util');

/*
 * TODO: common code here for the modals, ew, should have new widget
 */

module.exports = Modal.extend({

    baseModalDefaults: {
        hideFooter: true
    },

    contentTemplate: require('./template.hbs'),

    /*
    * Complete Fetched userModel, authModel, versionModel required.
    * */
    initialize: function( options ) {


        this.settings = _.extend( {}, {
            content: this.contentTemplate(
                this.serializeContentTemplateData( options.versionModel, options.userModel, options.authModel )
            )
        }, options );

        Modal.prototype.initialize.call( this, _.extend( {}, this.settings, this.baseModalDefaults) );

        return this;
    },


    serializeContentTemplateData: function( versionModel, userModel, authModel ) {

        var frig = require('./frig24-webfdd.png'), // may want to preload this or require once ... maybe use CSS / base64 image (?)
            userName = userModel.getUserName(),
            userDescription = userModel.getUserDescription(),
            userNameOrDescription = userDescription
                ? userDescription
                : userName,
            userGroupOfDerivedColor = userModel.getGroupOfDerivedUserColor();

        return {

            frigImageUrl: frig,

            clientVersion: versionModel.getVersion(),
            clientDate: versionModel.getFormattedDate(),
            dvServicesVersion: versionModel.servicesModel.getVersion(),
            dvServicesDate: versionModel.servicesModel.getBuild(),
            creVersion: versionModel.creServiceModel.getVersion(),
            creDate: versionModel.creServiceModel.getBuild(),
            copyRightDate: versionModel.getCopyRightDate(),

            userNameOrDescription: userNameOrDescription,
            userNameAndDatabase: userName + '@' + authModel.getDataService(), // (eg: ben@fdd92_pecan )

            userDerivedDrawingColor: userGroupOfDerivedColor
                ? userGroupOfDerivedColor.getColor()
                : null,

            userDerivedColorGroupName: userGroupOfDerivedColor
                ?  userGroupOfDerivedColor.getName()
                : null,

            userDeriveDrawingColorTitle: userGroupOfDerivedColor
                ? 'Drawing color derived from membership in group ' + userGroupOfDerivedColor.getName()
                : null


        };



    }


});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/dialogs/about/view.js
 ** module id = 264
 ** module chunks = 0
 **/